module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/navigation/horizontal/nav-item/nav-horizontal-item.component.scss
// module id = ./src/app/core/components/navigation/horizontal/nav-item/nav-horizontal-item.component.scss
// module chunks = main